module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Suhr_AG-f504f38f182613a8a1b20ddaa8100a3b.svg";